import React from "react";
import { string, func, bool, arrayOf, node } from "prop-types";

import { TextFieldGroup } from "../../../common";

const ContactTelephone = ({
  inputId = "",
  inputName = "",
  shouldDisplayError = false,
  handleChange,
  validation = undefined,
  valueName,
  title,
  number,
  classes = "",
}) => (
  <div className="form-group">
    <label htmlFor="telephone">{title}</label>
    <TextFieldGroup
      inputId={inputId}
      inputName={inputName}
      classes={`register_field form-control ${classes}`}
      value={number}
      onChange={(e) => {
        handleChange(valueName, e.target.value);
      }}
      validationMessages={validation}
      dontDisplayErrorMessage={!shouldDisplayError}
    />
  </div>
);

ContactTelephone.propTypes = {
  inputId: string,
  inputName: string,
  handleChange: func.isRequired,
  validation: arrayOf(node),
  valueName: string.isRequired,
  title: string.isRequired,
  number: string.isRequired,
  shouldDisplayError: bool,
  classes: string,
};

export default ContactTelephone;
